// extracted by mini-css-extract-plugin
export var bandeauAlertContainer = "bandeau-alert-module--bandeau-alert-container--2e819";
export var bandeauAlertTitle = "bandeau-alert-module--bandeau-alert-title--0ff48";
export var editButton = "bandeau-alert-module--edit-button--aed51";
export var sectionAlert = "bandeau-alert-module--section-alert--3723a";
export var sectionAlertButton = "bandeau-alert-module--section-alert-button--73991";
export var sectionAlertContent = "bandeau-alert-module--section-alert-content--19854";
export var sectionAlertHeader = "bandeau-alert-module--section-alert-header--86e0b";
export var sectionAlertModal = "bandeau-alert-module--section-alert-modal--6c796";
export var sectionAlertTitle = "bandeau-alert-module--section-alert-title--3cfe3";